import React from 'react';
import './App.css';

const App: React.FC = () => {
  return (
    <div className="App">
      <header className="App-header">
Welcome to this website. Prepare for your world to be rocked
      </header>
    </div>
  );
}

export default App;
